import { Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'
import DOMPurify from 'dompurify'

const RenderTemplate = ({ fetchFn, replacements, ...typographyProps }) => {
    const [content, setContent] = useState(null)

    useEffect(() => {
        async function fetchContent() {
            try {
                const template = await fetchFn(replacements)
                setContent(template.content)
            }
            catch (error) {
                console.error('error fetching template content', error)
            }
        }

        fetchContent()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    if (content == null) {
        return null
    }

    const sanitized = DOMPurify.sanitize(content, { ADD_ATTR: ['target'] })

    return (
        <Typography
            {...typographyProps}
            dangerouslySetInnerHTML={{ __html: sanitized }}
        />
    )
}

export default RenderTemplate
